const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

export const normalizeDate = (value: string): string => {
    const digits = value.replace(/\D/g, '');
    if (digits.length === 8) {
        return `${digits.slice(0, 4)}-${digits.slice(4, 6)}-${digits.slice(6, 8)}`;
    }
    return value;
};

export const calcEndDate = (startDate: string, days: number): string => {
    if (!startDate || days <= 0 || !DATE_RE.test(startDate)) return '';
    const d = new Date(startDate);
    if (isNaN(d.getTime())) return '';
    d.setDate(d.getDate() + days - 1);
    return d.toISOString().split('T')[0];
};

export const calcDays = (startDate: string, endDate: string): number => {
    if (!DATE_RE.test(startDate) || !DATE_RE.test(endDate)) return 0;
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (isNaN(start.getTime()) || isNaN(end.getTime())) return 0;
    return Math.floor((end.getTime() - start.getTime()) / 86400000) + 1;
};

export const formatPeriod = (startDay: string, endDay: string): string => {
    if (!startDay && !endDay) return '-';
    if (!endDay) return `${startDay} ~`;
    if (!startDay) return `~ ${endDay}`;
    return `${startDay} ~ ${endDay}`;
};
